import {VaultElementType} from "../../features/project/vaultElementSlice";
import {accessoryRepository} from "../../features/project/accessoryRepository";

export const getQuantityError = (
    quantity: number,
    elementName: string,
    plan: any,
    project: any
): string => {
    return !Number.isFinite(quantity)
        ? "Menge muss numerisch und ganzzahlig sein"
        : quantity < 0 || quantity > 1000
            ? "Menge muss zwischen 0 und 1000 liegen"
            : !projectHasElements(elementName, plan, project) && quantity < 1
                ? "Menge von mindestens einem Element muss mindestens 1 sein"
                : ''
}

const selectVaultElementQuantity = (project: any, type: VaultElementType): number => {
    return project.vaultElement.items.find((el: any) => el.elementType === type)?.quantity ?? 0;
}

const projectHasElements = (except: string, plan: any, project: any): boolean => {
    const hasVault = () => !!plan.vault && selectVaultElementQuantity(project, VaultElementType.Vault) > 0;
    const hasLid = () => !!plan.lid && selectVaultElementQuantity(project, VaultElementType.Lid) > 0;
    const hasIntermediateCeiling = () =>
        !!plan.intermediateCeiling && selectVaultElementQuantity(project, VaultElementType.IntermediateCeiling) > 0;
    const hasFloor = () => !!plan.floor && selectVaultElementQuantity(project, VaultElementType.Floor) > 0;

    return except === 'vault' ? hasLid() || hasIntermediateCeiling() || hasFloor() : except === 'lid'
        ? hasVault() || hasIntermediateCeiling() || hasFloor()
        : except === 'intermediateCeiling'
            ? hasVault() || hasLid() || hasFloor()
            : except === 'floor'
                ? hasVault() || hasLid() || hasIntermediateCeiling()
                : hasVault() || hasLid() || hasIntermediateCeiling() || hasFloor()
}

export const isElementCountValid = (plan: any, project: any): boolean => {
    return projectHasElements('', plan, project)
}

export type InvalidAccessory = {
    articleNumber: string;
    description: string;
    count: number;
    minOrderQuantity: number;
}

export const getInvalidAccessories = (project: any): InvalidAccessory[] => {
    if (!project.accessory || !project.accessory.items || project.accessory.items.length === 0) {
        return []; // No accessories in the cart, so it's valid
    }

    return project.accessory.items
        .filter((accessoryItem: any) => {
            if (!accessoryItem.count || accessoryItem.count === 0) {
                return false;
            }

            const repoItem = accessoryRepository.find(
                (repo: any) => repo.articleNumber === accessoryItem.articleNumber
            );

            if (!repoItem) {
                return false; // Can't validate if not found in repository
            }

            return accessoryItem.count < (repoItem.minOrderQuantity || 1);
        })
        .map((invalidItem: any) => {
            const repoItem = accessoryRepository.find(
                (repo: any) => repo.articleNumber === invalidItem.articleNumber
            );
            return {
                articleNumber: invalidItem.articleNumber,
                description: invalidItem.description,
                count: invalidItem.count,
                minOrderQuantity: (repoItem as any).minOrderQuantity || 1
            } as InvalidAccessory;
        });
};

export const isAccessoryQuantitiesValid = (project: any): boolean => {
    return getInvalidAccessories(project).length === 0;
};

